// SARA CONNOR monogram — broken neon ring + "S" glyph, cyan→blue→violet gradient.
import { useId } from "react";

export function SaraLogo({ className = "h-10 w-10" }) {
  // unique gradient id: duplicate ids break the stroke when the first instance is display:none
  const gid = `saraGrad-${useId().replace(/:/g, "")}`;
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="sara-logo"
      style={{ filter: "drop-shadow(0 0 8px rgba(0,240,255,0.45))" }}
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#00F0FF" />
          <stop offset="55%" stopColor="#00A3FF" />
          <stop offset="100%" stopColor="#8B5CF6" />
        </linearGradient>
      </defs>
      <circle
        cx="32"
        cy="32"
        r="27"
        stroke={`url(#${gid})`}
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeDasharray="120 50"
        opacity="0.9"
      />
      <path
        d="M42 23c-3.2-3-8.4-3.8-12.4-1.6-4 2.2-4.8 7-1.4 9.8 3.4 2.8 9.2 1.8 12.2 4.8 3 3 1.8 7.8-2.2 9.8-4 2-9.2 1-12.4-2"
        stroke={`url(#${gid})`}
        strokeWidth="4.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SaraLogo;
